import { render } from "./LoadingScreenComponent.vue?vue&type=template&id=bdba3b54&scoped=true"
const script = {}

import "./LoadingScreenComponent.vue?vue&type=style&index=0&id=bdba3b54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdba3b54"]])

export default __exports__